import { render, staticRenderFns } from "./SmartAlarmBox.vue?vue&type=template&id=f969126c&scoped=true"
import script from "./SmartAlarmBox.vue?vue&type=script&lang=js"
export * from "./SmartAlarmBox.vue?vue&type=script&lang=js"
import style0 from "./SmartAlarmBox.vue?vue&type=style&index=0&id=f969126c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f969126c",
  null
  
)

export default component.exports